import { render, staticRenderFns } from "./CallingPlanFlatRate.vue?vue&type=template&id=99857a82&scoped=true"
import script from "./CallingPlanFlatRate.vue?vue&type=script&lang=js"
export * from "./CallingPlanFlatRate.vue?vue&type=script&lang=js"
import style0 from "./CallingPlanFlatRate.vue?vue&type=style&index=0&id=99857a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99857a82",
  null
  
)

export default component.exports